import { post } from "mdui/api/HttpReq";
import { getField } from "mdui/form/Util";
import { isCurrentDateInFilename, isValidOPFRFilename } from "./commonUtils";
import { AlertType } from "mdui/page/MsgBox";
import { t } from "i18next";


export const debitTypeOnChange = async ({ props, formData, updateState, config, setCfg, ...data }) => {
    let res = await processDebitTypeOnChange(formData, config);

    // updateState({ newFormData, newAttr: attr })
    updateState(res)
}

const processDebitTypeOnChange = async (formData, config) => {
    let hideFields = false;
    let trxnCd = 'IHCT.DMCT.1000';

    console.log('debitTypeOnChange config', config)

    if (formData.dbtType === 'M') {
        hideFields = true;
        trxnCd = 'IHCT.DMCT.2000';
    }
    else {
        hideFields = false;
        trxnCd = 'IHCT.DMCT.1000';
    }

    let attr = {
        chnlInstrId: { hide: hideFields },
        rcpntRef: { hide: hideFields },
        othrPymtDtl: { hide: hideFields },
        applDetSect: { hide: hideFields },
        instrTable: { hide: hideFields },
        instrTableMM: { hide: !hideFields }
    };

    let newFormData = {
        ...formData,
        trxnCd
    }

    return { newFormData, newAttr: attr }
}

const processCbftTypeOnChange = async (formData, config) => {
    let hideFields = false;
    let trxnCd = 'ISCT.XBCT.1000';

    console.log('debitTypeOnChange config', config)

    if (formData.dbtType === 'M') {
        hideFields = true;
        trxnCd = 'ISCT.XBCT.2000';
    }
    else {
        hideFields = false;
        trxnCd = 'ISCT.XBCT.1000';
    }

    let attr = {
        chnlInstrId: { hide: hideFields },
        rcpntRef: { hide: hideFields },
        othrPymtDtl: { hide: hideFields },
        applDetSect: { hide: hideFields },
        instrTable: { hide: hideFields },
        instrTableMM: { hide: !hideFields }
    };

    let newFormData = {
        ...formData,
        trxnCd
    }

    return { newFormData, newAttr: attr }
}

export const debitCcyOnChangeBulk = async ({ props, formData, updateState, config, setCfg, ...data }) => {
    let newFormData = {
        ...formData,
        trxnCcy: formData.debitCcy
    }

    if (formData.batchDbtType === 'M') {
        newFormData = {
            ...newFormData,
            creditRate: '',
            debitRate: '',
            txFee: '',
            fxContractRefNum: '',
            creditAmt: ''
        }
    }

    updateState({ newFormData })
}

export const debitTypeOnChangeFAST = async ({ props, formData, updateState, config, setCfg, ...data }) => {
    let trxnCdCfg = data.ctrlCfg[props.field.moduleId + '_trxnCd'];
    let res = await processDebitTypeOnChangeFast(formData, trxnCdCfg);
    updateState(res)
}
const processDebitTypeOnChangeFast = async (formData, trxnCdCfg) => {
    let hideFields = false;
    let trxnCd;
    if (formData.dbtType === 'M') {
        hideFields = true;
        trxnCd = trxnCdCfg ? trxnCdCfg.find(item => item?.val.endsWith('2000'))?.val : null;
    } else {
        hideFields = false;
        trxnCd = trxnCdCfg ? trxnCdCfg.find(item => item?.val.endsWith('1000'))?.val : null;
    }
    if (!trxnCd) {
        trxnCd = formData.trxnCd;
    }
    let attr = {
        chnlInstrId: { hide: hideFields },
        rcpntRef: { hide: hideFields },
        othrPymtDtl: { hide: hideFields },
        applDetSect: { hide: hideFields },
        instrTable: { hide: hideFields },
        instrTableMM: { hide: !hideFields }
    };

    let newFormData = {
        ...formData,
        trxnCd,
        submitBtnFlag: true
    }

    return { newFormData, newAttr: attr }
}
export const debitTypeOnChangeIBG = async ({ props, formData, updateState, config, setCfg, ...data }) => {
    let res = await processDebitTypeOnChangeIbg(formData, config);

    // updateState({ newFormData, newAttr: attr })
    updateState(res)
}
const processDebitTypeOnChangeIbg = async (formData, config) => {
    let hideFields = false;
    let trxnCd = 'IACT.ATXN.1000';

    console.log('debitTypeOnChange config', config)

    if (formData.dbtType === 'M') {
        hideFields = true;
        trxnCd = 'IACT.ATXN.2000';;
    }
    else {
        hideFields = false;
        trxnCd = 'IACT.ATXN.1000';;
    }

    let attr = {
        chnlInstrId: { hide: hideFields },
        rcpntRef: { hide: hideFields },
        othrPymtDtl: { hide: hideFields },
        applDetSect: { hide: hideFields },
        instrTable: { hide: hideFields },
        instrTableMM: { hide: !hideFields }
    };

    let newFormData = {
        ...formData,
        trxnCd
    }

    return { newFormData, newAttr: attr }
}

export const instrBackBtnCallback = async ({ props, formData, updateState, config, setCfg, ...data }) => {
    console.log('instrBackBtnCallback formData', formData)
}

const loadData = async (module, action, props, formData, tblProps = {}) => {
    let tableCfg = (formData?.table?.[props.module]) ?? { page: 0, perPage: 10 };
    let param = { ...formData, module: props.module, action: props.action, page: (tableCfg.page ? tableCfg.page : 0), perPage: (tableCfg.perPage ? tableCfg.perPage : 10), tblProps: tblProps };
    let val = await post(module, action, param);
    let table = {
        ...formData?.table, [props.module]: {
            page: (tableCfg.page ? tableCfg.page : 0), perPage: (tableCfg.perPage ? tableCfg.perPage : 10),
            rows: val.content, count: val.totalElements
        }
    }
    return table;
}

const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const [yyyy, mm, dd] = dateStr.split('-');
    return `${dd}-${mm}-${yyyy}`;
};

export const wuiUploadMEPS = async ({ props, formData, files, updateState, event, config, ...data }) => {

    // const { openModel } = useUtil();
    if (!isValidOPFRFilename(data?.data?.files[0].name)) {
        alert("Invalid filename")
        // openModel({ msg: 'file_invalid_name', type: AlertType.E });
        return;
    }
    if (!isCurrentDateInFilename(data?.data?.files[0].name)) {
        console.log("Invalid date in filename")
        // openModel({ msg: 'file_invalid_dt', type: AlertType.E });
        alert("Invalid filename, Filename must be in current date")
        return;
    }

    const form = new FormData();
    form.append('file', data?.data?.files[0]);
    form.append('module', props.module);
    form.append('action', 'upload');
    form.append('parentPK', config.initPK);
    //bp-upload/upload
    let val = await post('bp-upload', 'upload', form)
    let parentPK = config.initPK || '';
    let tbl = getField(config.pages[config.cPKey].config, props.field.callbackArgs);
    let nData = await loadData('md-mod-cfg', 'read', { module: tbl.module, action: 'add' }, { initOpr: 'add', parentPK, ...formData }, tbl);

    val = { ...val, valueDt: formatDate(val?.valueDt) }

    let newFormData = { ...formData, ...val, table: nData }
    let res = await processDebitTypeOnChange(newFormData, config);
    res = {
        ...res,
        newAttr: {
            ...res.newAttr,
            headerSect: { hide: false },
            Group_1: { hide: false },
            txnSumSect: { hide: false },
            uTxnSumSect: { hide: false }
        }
    }
    // updateState({ newFormData })
    updateState(res)
}

export const wuiUploadCbft = async ({ props, formData, files, updateState, event, config, ...data }) => {

    // const { openModel } = useUtil();
    if (!isValidOPFRFilename(data?.data?.files[0].name)) {
        alert("Invalid filename")
        // openModel({ msg: 'file_invalid_name', type: AlertType.E });
        return;
    }
    if (!isCurrentDateInFilename(data?.data?.files[0].name)) {
        console.log("Invalid date in filename")
        // openModel({ msg: 'file_invalid_dt', type: AlertType.E });
        alert("Invalid filename, Filename must be in current date")
        return;
    }

    const form = new FormData();
    form.append('file', data?.data?.files[0]);
    form.append('module', props.module);
    form.append('action', 'upload');
    form.append('parentPK', config.initPK);
    //bp-upload/upload
    let val = await post('bp-upload', 'upload', form)
    let parentPK = config.initPK || '';
    let tbl = getField(config.pages[config.cPKey].config, props.field.callbackArgs);
    let nData = await loadData('md-mod-cfg', 'read', { module: tbl.module, action: 'add' }, { initOpr: 'add', parentPK, ...formData }, tbl);

    val = { ...val, valueDt: formatDate(val?.valueDt) }

    let newFormData = { ...formData, ...val, table: nData }
    let res = await processCbftTypeOnChange(newFormData, config);
    res = {
        ...res,
        newAttr: {
            ...res.newAttr,
            headerSect: { hide: false },
            Group_1: { hide: false },
            txnSumSect: { hide: false },
            uTxnSumSect: { hide: false }
        }
    }
    // updateState({ newFormData })
    updateState(res)
}

export const wuiUploadFAST = async ({ props, formData, files, updateState, event, config, ...data }) => {
    const form = new FormData();
    form.append('file', data?.data?.files[0]);
    form.append('module', props.field.moduleId);
    form.append('action', 'upload');
    form.append('parentPK', config.initPK);
    //bp-upload/upload
    let val = await post('bp-upload', 'upload', form)
    let fileError = val.FILE_ERROR;
    if (fileError) {
        let newMsg = { key: t(`${props.field.moduleId}.${fileError}`), type: AlertType.E };
        let nattr = {
        //    upldPymtFileTab: { headerSect: { hide: true, dbtType: { readOnly: true } } },
            Group_1: { hide: true },
            txnSumSect: { hide: true },
            rqstDet: { hide: true },
            submit: { disabled: true }
        };
        updateState({ newMsg, newAttr: nattr, replaceAttr: true });
        return;
    }

    let parentPK = config.initPK || '';
    let tbl = getField(config.pages[config.cPKey].config, props.field.callbackArgs);
    let nData = await loadData('md-mod-cfg', 'read', { module: tbl.module, action: 'add' }, { initOpr: 'add', parentPK, ...formData }, tbl);

    val = { ...val, valueDt: val?.valueDt, fileNm: val.filename }
    let nattr = {}
    const errors = val.errors;
    let isError = false;
    if (Array.isArray(errors)) {
        errors.forEach((errObj) => {
            Object.entries(errObj).forEach(([field, errKey]) => {
                nattr[field] = { err: errKey };
                isError = true;
            });
        });
    } else if (errors && typeof errors === "object") {
        Object.entries(errors).forEach(([field, errKey]) => {
            nattr[field] = { err: errKey };
            isError = true;
        });
    }

    if (isError) {
        nattr["create"] = { disabled: true };
        nattr["submit"] = { disabled: true };
    } else {
        nattr["create"] = { disabled: false };
        nattr["submit"] = { disabled: false };
    }
    let newMsg;
    if (val.warnings) {
        newMsg = { key: val.warnings, type: AlertType.W };
    }
    val.totTxnCount = val.totRec
    let newFormData = { ...formData, ...val, prevFileNm: '', table: nData }
    let res = await processDebitTypeOnChangeFast(newFormData);
    let isSingleDebit = 'S' === formData.dbtType;
    console.log('formData.trxnCd', formData)
    let chnlInstrIdHide = false;
        if (formData.trxnCd.includes('ISCT.XBCT') || formData.trxnCd.includes('IHCT.DMCT')) {

            chnlInstrIdHide = true;
        }
    

  
    res = {
        ...res,
        newMsg,
        newAttr: {
            ...res.newAttr,
            ...nattr,
           upldPymtFileTab: { headerSect: { hide: false, dbtType: { readOnly: true }
           , trxnCd: { readOnly: true }, trxnDt: { readOnly: true }, valueDt: { readOnly: true }, bizDt: { readOnly: true }, rqstChnl: { readOnly: true }, chnlInstrId: { hide: !chnlInstrIdHide }} },
         //headerSect: { hide: false},
            Group_1: { hide: false },
            txnSumSect: { hide: false },
            rqstDet: { hide: false },
            ccy:{readOnly: isSingleDebit},
            submit:{disabled: false}
        },
        replaceAttr: true
    }
    // updateState({ newFormData })

    updateState(res)
}
export const wuiUploadIBG = async ({ props, formData, files, updateState, event, config, ...data }) => {
    await wuiUploadFAST({ props, formData, files, updateState, event, config, ...data });
}

export const createMepsInstr = async ({ props, formData, updateState, config, fnName, ctrlCfg, setCfg, validate, create, ...data }) => {
    if (validate(props)) {
        create({ props, formData, updateState, config, fnName, ctrlCfg, setCfg, validate, create, ...data })
    }
    
}

